import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    MailOutline,
    LockOutlined,
    LocalShipping,
    ErrorOutline,
    CheckCircleOutline,
    InfoOutlined,
    AssignmentInd,
    HomeOutlined,
    MoveToInboxOutlined,
    PeopleAltOutlined,
    VisibilityOutlined,
    SecurityOutlined,
    ArchiveOutlined
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3, pb: 8 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアでの郵便物・宅配便管理の重要性
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('postbox')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    共有ポストの使い方と注意点
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('deliverybox')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    宅配ボックスの便利な活用法
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('privacy')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    個人情報を守る！郵便物管理のポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    受け取りトラブルを防ぐコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめとチェックリスト
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}
            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアでの郵便物・宅配便管理の重要性
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェア生活では、複数人が同じ住所を共有します。これにより郵便物や宅配便の管理は意外と複雑になりがちです。<b>大切な書類やプライベートな荷物が誤って他のルームメイトの手に渡ってしまったり、不在時に荷物が受け取れず困ったり…</b>そんなトラブルを未然に防ぎ、快適なシェア生活を送るためのコツを徹底解説します。
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    この記事では、<b>共有ポストの賢い使い方</b>から<b>宅配ボックスの活用</b>、<b>個人情報保護</b>、<b>受け取りトラブルの回避</b>まで、すぐに実践できるノウハウを紹介します。ルームシェア経験者の視点から、具体的なアイデアや、実際の現場でよくある課題への対策も盛り込んでいるので、これからシェア生活を始める方も、既に暮らしている方もぜひご参考ください。
                </Typography>
            </Box>
            {/* 共有ポストの使い方 */}
            <Box id="postbox" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    共有ポストの使い方と注意点
                </Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={5}>
                        <Box sx={{ borderRadius: 2, overflow: 'hidden', mb: { xs: 2, md: 0 } }}>
                            <img
                                src="/images/blog/postbox_roomshare-mail-management.jpg"
                                alt="マンションのエントランスに設置された複数口の共有ポスト。明るい照明と整理された雰囲気で、住人が郵便物を確認している様子が映っている。ルームシェアでの郵便物管理のイメージに最適。"
                                width="100%"
                                style={{ borderRadius: 8, display: 'block' }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            通常物件の多くには、エントランスにポストが設置されています。<b>複数人で使うからこそ、ルール作りが大切</b>です。以下のポイントを押さえて、トラブルを防ぎましょう。
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon><MailOutline color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary={<b>氏名・部屋番号の表記を統一</b>}
                                    secondary="全員分の名前や部屋番号を表札に明記し、配達員が迷わないようにすることで誤配を防げます。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><AssignmentInd color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary={<b>郵便物の仕分けルールを決める</b>}
                                    secondary="誰がいつ仕分け・回収するか事前に決めておくと、取り違えや放置が減らせます。"
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon><MoveToInboxOutlined color="primary" /></ListItemIcon>
                                <ListItemText
                                    primary={<b>ポスト内の整理をこまめに</b>}
                                    secondary="古いチラシや不要な郵便物は定期的に片付け、スペースを確保しましょう。"
                                />
                            </ListItem>
                        </List>
                        <Chip label="POINT" color="primary" variant="outlined" sx={{ mt: 1, mr: 1 }} />
                        <Typography variant="body2" sx={{ display: 'inline', color: 'text.secondary' }}>
                            共有ポストには鍵付きも多いですが、<b>鍵の管理</b>も非常に重要です。紛失やコピーの取扱いについてもルールを作っておくと安心です。
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
            {/* 宅配ボックス活用 */}
            <Box id="deliverybox" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    宅配ボックスの便利な活用法
                </Typography>
                <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: '#fafafa' }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={7}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                不在でも荷物を受け取れる宅配ボックスは、ルームシェアで特に重宝される設備です。ですが「誰の荷物か分からない」「開けたものの中身が自分宛じゃなかった」ということも。<b>みんなが安心して使えるための工夫</b>を知っておきましょう。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><LocalShipping color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="宛名・部屋番号をしっかり記載"
                                        secondary="通販サイトの登録住所を見直し、必ず自分の名前＋部屋番号を入力しましょう。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><InfoOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="宅配ボックス利用後は即連絡"
                                        secondary="荷物を受け取ったら、グループチャット等ですぐに報告。誰の荷物か迷わない工夫が大切です。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><CheckCircleOutline color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="宅配ボックスの利用ルールを共有"
                                        secondary="長時間放置しない、受け取り後の解錠方法など、物件ごとにルールを決めておきましょう。"
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Box sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                <img
                                    src="/images/blog/deliverybox_roomshare-mail-management.jpg"
                                    alt="エントランスに設置された宅配ボックスと宅配員。明るい日差しの下、住人が荷物を受け取っているシーンで、ルームシェアの荷物管理の利便性を表現している。"
                                    width="100%"
                                    style={{ borderRadius: 8, display: 'block' }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        <b>宅配ボックスがない物件</b>でも、ルームメイトが代わりに荷物を受け取る場合は、<b>受け取り記録ノートを作成</b>すると確実です。宅配伝票の控えを貼っておくなど、アナログな方法も意外と効果的ですよ。
                    </Typography>
                </Box>
            </Box>
            {/* 個人情報を守る！郵便物管理のポイント */}
            <Box id="privacy" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    個人情報を守る！郵便物管理のポイント
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, bgcolor: '#f5faff', mb: 2 }}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                ルームシェアでは、<b>他人の郵便物の情報が目に入る</b>機会が増えます。<b>個人情報保護</b>の観点から、以下のことに気をつけましょう。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><LockOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="他人の郵便物は絶対に開封しない"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><VisibilityOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="宛名・住所などを不用意に口外しない"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><SecurityOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="転送届や重要書類は本人のみが管理"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ borderRadius: 2, overflow: 'hidden', mt: { xs: 2, md: 0 } }}>
                            <img
                                src="/images/blog/privacy_roomshare-mail-management.jpg"
                                alt="各ルームメイトごとに仕分けられた郵便物が、個別トレーに分けて置かれている。清潔感のある明るいダイニングテーブルで、誰の郵便物か一目でわかる工夫がされている場面。"
                                width="100%"
                                style={{ borderRadius: 8, display: 'block' }}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    最近は<b>マイナンバー通知書や銀行の書類など、重要な郵便物も増加</b>しています。受け取った郵便物は必ず本人に直接手渡す、または決められた保管場所に置くルールを徹底しましょう。
                </Typography>
                <Chip label="個人情報保護" color="primary" variant="outlined" sx={{ mr: 1 }} />
                <Chip label="プライバシー" color="primary" variant="outlined" />
            </Box>
            {/* 受け取りトラブルを防ぐコツ */}
            <Box id="trouble" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    受け取りトラブルを防ぐコツ
                </Typography>
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#fff3e0', mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={7}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                ルームシェアで最も多いのが、<b>「荷物が受け取れなかった」「誰かが間違えて開封してしまった」</b>といったトラブルです。シェア生活を快適にするための防止策をまとめました。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon><ErrorOutline color="error" /></ListItemIcon>
                                    <ListItemText
                                        primary="お互いの配達予定をシェア"
                                        secondary="配達予定日をグループLINEやホワイトボードで共有しておくと、誰かが代わりに受け取りやすくなります。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><PeopleAltOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="受け取りや代理サイン時は必ず報告"
                                        secondary="代理で受け取った場合は、すぐに本人に連絡し、荷物を所定の場所に保管しましょう。"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon><ArchiveOutlined color="primary" /></ListItemIcon>
                                    <ListItemText
                                        primary="保管場所と受け渡しルールを明確に"
                                        secondary="玄関横に「一時保管BOX」を設置し、誰の荷物か分かるメモを添えておくとスムーズです。"
                                    />
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Box sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                <img
                                    src="/images/blog/delivery-trouble_roomshare-mail-management.jpg"
                                    alt="玄関付近に設置された一時保管ボックスと、荷物を手渡しするルームメイト。明るい室内で和やかな雰囲気の中、受け取りトラブルを未然に防ぐコミュニケーションが行われている。"
                                    width="100%"
                                    style={{ borderRadius: 8, display: 'block' }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                    防犯・プライバシーのため<b>宅配業者や郵便局への「共有住宅」表記や注意メモ</b>をポストに貼るのも効果的です。配達員への配慮も忘れずに！
                </Typography>
            </Box>
            {/* まとめとチェックリスト */}
            <Box id="summary">
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめとチェックリスト
                </Typography>
                <Paper elevation={0} sx={{ p: 2, borderRadius: 2, bgcolor: '#f1f8e9', mb: 2 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ルームシェアの郵便・宅配管理は、<b>「ルール作り」×「コミュニケーション」</b>が成功のカギ。トラブルを避けるため、以下のチェックポイントも参考にしてみてください。
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="ポスト・宅配ボックスの氏名表記は全員分になっている" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="郵便物の仕分け・回収の当番やルールが決まっている" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="代理受取や保管時の連絡方法・保管場所が明確" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="誰かが受け取った場合は、必ず速やかに報告している" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="個人情報の取り扱いについてメンバー内で意識共有ができている" />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    少しの配慮と工夫で、ルームシェアの郵便・宅配トラブルはグッと減らせます。<b>みんなが安心して暮らせる環境づくり</b>、ぜひ実践してみてください！
                </Typography>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-mail-management',
    slug: 'roomshare-mail-management',
    title: 'ルームシェアでの郵便物・宅配便の管理方法',
    excerpt: '共有ポストの使い方、宅配ボックス活用、個人情報保護、受け取りトラブル防止まで、ルームシェア生活で役立つ郵便・宅配管理術を徹底解説。',
    coverImage: '/images/blog/cover-roomshare-mail_roomshare-mail-management.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが和やかに郵便物を手に取り、荷物を仕分けしている様子。各自の郵便物がきちんと分けられていることで、安心感と信頼が伝わる雰囲気を表現。',
    publishedAt: '2024-06-14T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '生活ノウハウ', '防犯・マナー'],
    tags: ['郵便物管理', '宅配ボックス', '個人情報保護', 'トラブル防止', 'ルームシェア'],
    author: {
        name: '高橋 理沙',
        avatar: '/images/avatars/risa-takahashi.jpg',
        bio: 'ルームシェア歴8年の生活ジャーナリスト。多様な住まい方や共同生活の課題・解決策を独自の視点で発信。全国のシェアハウス取材経験多数。',
        profilePicture: '/images/avatars/risa-takahashi.jpg'
    },
    viewCount: 1024,
    contentComponent: PostContent
};

export default post;